import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Footer from './components/Footer';
import Header from './components/Header';
import AppRouter from './routes/AppRouter';

const App = () => {
  const location = useLocation();
  const [hideFooter, setHideFooter] = useState(false);

  // Обновляем состояние hideFooter на основе location.state
  useEffect(() => {
    if (location.state?.hideBlocks) {
      setHideFooter(true);
    } else {
      setHideFooter(false);
    }
  }, [location.state]);

  return (
    <div>
      <Header />
      <AppRouter />
      {!hideFooter && <Footer />} {/* Условный рендеринг футера */}
    </div>
  );
};

export default App;
